import { useState } from 'react';
import ban100 from '../../../assets/ban100w.png';

export default function CdtResultCard({ tasa = 0.1 }) {
  const [montoInicial, setMontoInicial] = useState(5000000);
  const [montoFinal, setMontoFinal] = useState(montoInicial * (1 + tasa));

  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  
  const handleInputChange = (e) => {
    const valor = e.target.value.replace(/\./g, '');
    if (!isNaN(valor)) {
      setMontoInicial(Number(valor));
    }
  };

  const handleSimular = () => {
    const nuevoMontoFinal = montoInicial * (1 + tasa);
    setMontoFinal(nuevoMontoFinal);
  };

  return (
    <div className="bg-[#e8f2f4] w-[400px] p-6 rounded-2xl shadow-lg mb-4">
      <h3 className="text-[#0054c9] font-extrabold text-lg mb-2">Tu inversión por (COP)</h3>
      <div className="flex items-center bg-[#c1dbff] p-3 rounded-lg mb-4">
        <input
          type="text"
          value={formatNumber(montoInicial)}
          onChange={handleInputChange}
          placeholder="Ingresa el monto"
          className="w-full text-lg font-semibold bg-transparent outline-none text-[#032c65] mr-4"
        />
        <button onClick={handleSimular} className="bg-[#36a31a] text-white font-bold py-1 px-4 rounded-lg hover:bg-[#55b03e]">
          Simular
        </button>
      </div>
      
      <h3 className="text-[#0054c9] font-extrabold text-lg mb-2">Te puede generar a 18 meses</h3>
      <div className="flex items-center bg-[#c1dbff] p-3 rounded-lg mb-4">
        <span className="text-[#032c65] font-semibold text-lg">💲 {montoFinal.toLocaleString()}</span>
      </div>

      <h3 className="text-[#0054c9] font-extrabold text-xl mb-2">Escogiendo a</h3>
      <div className="flex justify-left mb-4">
        <img src={ban100} alt="Ban100" className="w-32 h-auto" />
      </div>
      <p className="text-[#0054c9] font-bold text-lg mb-4">
        Porque tiene la mejor rentabilidad y abriéndolo con MEU
      </p>
      <p className="text-[#0054c9] font-bold text-lg mb-6">
        Puedes retirar hasta $10M antes del vencimiento, completamente gratis.
      </p>

      <button className="w-full bg-[#36a31a] text-white font-bold text-lg py-2 rounded-lg hover:bg-[#55b03e]">
        ¡Abre tu CDT!
      </button>
    </div>
  );
}
